import Subscribe from '../../utils/subscribe'

export default Subscribe()